// A bitrate ladder (config/ladder.go): renditions below an encode's own
// picture, sent together as adaptive HLS by an hls_push with `adaptive`.
export interface Rung {
    height: number
    bitrate_k: number
}

export const maxRungs = 5
// the heights offered, the usual steps of a ladder
export const rungHeights = [1440, 1080, 720, 540, 480, 360, 270, 240, 180, 144]

// the rung "+ rendition" adds below the last one (or the encode's own
// picture, topH tall at topK kbit/s): the next usual height down, its
// bitrate scaled by its pixels to the power 0.75 (smaller pictures need
// more bits a pixel); undefined when none is left below
export function nextRung(ladder: Rung[], topH: number, topK: number): Rung | undefined {
    const last = ladder.at(-1)
    const aboveH = last?.height ?? (topH || 1080)
    const aboveK = last?.bitrate_k ?? topK
    const height = rungHeights.find((h) => h < aboveH)
    if (!height || ladder.length >= maxRungs) return undefined
    const k = Math.round((aboveK * Math.pow((height * height) / (aboveH * aboveH), 0.75)) / 50) * 50
    return { height, bitrate_k: Math.max(k, 100) }
}

// the ladder as the API takes it (none: undefined)
export function ladderBody(ladder: Rung[] | undefined): Rung[] | undefined {
    if (!ladder?.length) return undefined
    return ladder.map((r) => ({ height: Number(r.height), bitrate_k: Number(r.bitrate_k) }))
}
